<template>
  <div :class="['returnClass', { inApp: $root.$data.isApp }]">
    <common-title
      titleName="课程升级"
      :zIndex="1000"
    ></common-title>
    <replaceClass />
    <!--  隐藏退货标签，如果需要恢复，注释代码放开， replaceClass组件删除 -->
<!--    <van-tabs-->
<!--      title-active-color="#FF6C02FF"-->
<!--      color="#FF6C02FF"-->
<!--      v-model="activeName"-->
<!--      swipeable-->
<!--      @click="changeTab"-->
<!--    >-->
<!--      <van-tab-->
<!--        v-for="(pages, index) in pages"-->
<!--        :key="index"-->
<!--        :name="pages.name"-->
<!--        :title="pages.label"-->
<!--      >-->
<!--        <div class="returnClass&#45;&#45;body">-->
<!--          <components-->
<!--            :is="pages.name"-->
<!--            v-if="pages.name == activeName"-->
<!--          ></components>-->
<!--        </div>-->
<!--      </van-tab>-->
<!--    </van-tabs>-->
    <Foot />
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import Foot from '@/components/foot/privacy.vue';
import replaceClass from './replaceClass/replaceClass.vue';
// import exitClass from './exitClass/exitClass.vue';

export default {
  data() {
    return {
      activeName: 'replaceClass',
      nowPage: 'replaceClass',
      pages: [
        {
          name: 'replaceClass',
          label: '换课',
        },
        {
          name: 'exitClass',
          label: '退课',
        },
      ],
      scroll: null,
    };
  },

  components: {
    CommonTitle,
    replaceClass,
    // exitClass,
    Foot,
  },

  computed: {},

  mounted() { },

  created() { },

  methods: {
    // 切换标签
    changeTab(name) {
      this.activeName = name;
    },
  },
  // 进入路由之前执行的函数
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => { });
  // },
};
</script>
<style lang="scss" scoped>
::v-deep .common-foot {
  position: fixed;
}
.returnClass {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #f9f9f9ff;

  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  ::v-deep .van-tabs {
    height: 100%;
    &__content {
      height: 100%;
    }
  }
  ::v-deep .van-tab__text {
    font-size: 0.4rem;
  }
  ::v-deep .van-tab__text--ellipsis {
    width: 100%;
    text-align: center;
    border-right: 1px solid #e1e1e1;
  }
  ::v-deep .van-tabs--line {
    .van-tabs__wrap {
      z-index: 500;
      width: 100%;
    }
  }
  ::v-deep .van-tab--active {
    color: rgb(255, 108, 2);
  }
  ::v-deep .van-tabs__line {
    background-color: rgb(255, 108, 2) !important;
  }
  ::v-deep .van-tabs__nav {
    .van-tab:nth-of-type(2) span {
      border-right: none;
    }
  }
  &--body {
    height: 100%;
    padding: 0 36px 10px;
    background: #f9f9f9ff;
  }
}
</style>
